import { Outlet } from 'react-router-dom'
import TeamLeaderBottomNav from '../components/TeamLeaderBottomNav'

export default function TeamLeaderLayout() {
  return (
    <>
      <Outlet />
      <TeamLeaderBottomNav />
    </>
  )
}